var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 31 31",
    enableBackground: "new 0 0 31 31",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "19.1,15.5 29.2,5.3 29.9,4.6 29.2,3.9 27.1,1.8 26.4,1.1 25.7,1.8 15.5,11.9 5.3,1.8 4.6,1.1 3.9,1.8 1.8,3.9 1.1,4.6 1.8,5.3 11.9,15.5 1.8,25.7 1.1,26.4 1.8,27.1 3.9,29.2 4.6,29.9 5.3,29.2 15.5,19.1 25.7,29.2 26.4,29.9 27.1,29.2 29.2,27.1 29.9,26.4 29.2,25.7 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.e61dc6b775f4b33e05698c0bc6251a9e.svg";
export { ForwardRef as ReactComponent };